import { GetchErrorCode } from '@golden/getch';
import { BehaviorSubject, tap } from 'rxjs';
export function createAuthorization() {
    const isLoginSubject = new BehaviorSubject(true);
    return {
        isLoginSubject,
        ifUnauthorized() {
            return tap((error) => {
                if (error.code === GetchErrorCode.STATUS_CODE && error.response.status === 401) {
                    isLoginSubject.next(false);
                }
            });
        }
    };
}
//# sourceMappingURL=Authorization.js.map